<template>
  <header>
    <!-- menu later might be here -->
  </header>
</template>

<script>
export default {
  name: 'LayoutHeader'
}
</script>
